export const FALLBACK_EMAIL = 'указанный адрес.';
